import {NfMessage, NfMessageType} from "../NfMessage";
import {NfComponentMessage} from "../NfComponentMessage";
import {isProxy} from "vue";
import {unPackProxyObject} from "../../../utilities/nonDomUtils";
import type {RoomPeopleConfiguration} from "../Models/RoomPeopleConfiguration";
import {isEqual} from "lodash-es";

var nextRequestId = 1;
/**
 * Wiadomość, gdy potrzebna jest dostępność pokojów, do service workera
 */
export class GetAvailability extends NfComponentMessage {
    public fromDate: string = '';
    public toDate: string = '';
    public adultsCount: number = 0;
    public childAges: number[] | undefined;
    public filterOffers: number[] | undefined;
    public filterStandards: number[] | undefined;
    public exceptStandardDescriptions: number[] | undefined;
    public packetId: number | undefined;
    public discountCode: string | undefined;
    public searchForClosestPeriod: boolean | undefined;
    /** This number is important to recognize which request gets which response */
    public requestId: number = nextRequestId++;
    declare public noRoomStandardDescriptions: boolean;
    public constructor(widgetId: number|MessageEvent<GetAvailability>, languageId?: number,
                       fromDate?: string, toDate?: string, adultsCount?: number, childAges?:number[],
                       filterOffers?: number[], filterStandards?: number[], exceptStandardDescriptions?: number[],
                       packetId?: number, discountCode?: string, searchForClosestPeriod?:boolean, noRoomStandardDescriptions?:boolean,
                       public noPropositions:boolean = true, public extraRooms: RoomPeopleConfiguration[] = []) {
        super(NfMessageType.GetAvailability);
        if(NfMessage.isMessageEvent(widgetId)) {
            Object.assign(this, widgetId.data);
        } else {
            this.widgetId = widgetId;
            if(!languageId) {
                throw Error('id języka jest wymagany');
            }
            this.languageId = languageId;
            if(!fromDate) {
                throw Error('fromDate jest wymagany');
            }
            this.fromDate = fromDate;

            if(!toDate) {
                throw Error('toDate jest wymagany');
            }
            this.toDate = toDate;

            if(!adultsCount) {
                throw Error('adultsCount jest wymagany');
            }
            this.adultsCount = adultsCount;

            this.childAges = childAges;
            this.filterOffers = filterOffers;
            this.filterStandards = filterStandards;
            this.exceptStandardDescriptions = exceptStandardDescriptions;
            this.packetId = packetId;
            this.discountCode = discountCode;
            this.searchForClosestPeriod = searchForClosestPeriod;
            this.noRoomStandardDescriptions = !!noRoomStandardDescriptions;
            if(isProxy(extraRooms)) {
                this.extraRooms = unPackProxyObject(extraRooms);
            }
        }
    }
    public type = NfMessageType.GetAvailability;
    /**
     * id widgeta dla backendu nfHotel
     */
    public widgetId:number = 0;
    /**
     * id języka
     */
    public languageId:number = 1;

    /** Checking if availability request is the same as another one (repeated request) */
    public isSameAs(message: GetAvailability): boolean {
        return this.fromDate === message.fromDate && this.toDate === message.toDate && this.adultsCount === message.adultsCount &&
            isEqual(this.childAges, message.childAges) && isEqual(this.filterOffers, message.filterOffers) &&
            isEqual(this.filterStandards, message.filterStandards) && isEqual(this.exceptStandardDescriptions, message.exceptStandardDescriptions) &&
            this.packetId === message.packetId && this.discountCode === message.discountCode && this.searchForClosestPeriod === message.searchForClosestPeriod;
    }
}
NfMessage.creationCallbacks[NfMessageType.GetAvailability] = (event) => {
    return new GetAvailability(event);
}
